import { render, staticRenderFns } from "./FeedbackHomework.vue?vue&type=template&id=991c21a2&scoped=true"
import script from "./FeedbackHomework.vue?vue&type=script&lang=js"
export * from "./FeedbackHomework.vue?vue&type=script&lang=js"
import style0 from "./FeedbackHomework.vue?vue&type=style&index=0&id=991c21a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c21a2",
  null
  
)

export default component.exports